<template>
  <div v-if="input && typeof input === 'object' && input.length === 3" class="form-row">
    <div class="form-field w-30 pr-0">
      <input type="number" v-model="input[2]" required min="1" :max="maxDay" placeholder="Dag*" class="border-right-0 br-0">
    </div>
    <div class="form-field w-30 pr-0">
      <input type="number" v-model="input[1]" required min="1" max="12" placeholder="Maand*" class="border-right-0 br-0 bl-0">
    </div>
    <div class="form-field w-30">
      <input type="number" v-model="input[0]" required min="1900" :max="new Date().getFullYear() - 10" placeholder="Jaar*" class="bl-0">
    </div>
  </div>
</template>

<script>
  export default {
    props: ['value'],
    data () {
      return {
        input: this.value ? this.value : ['','','']
      }
    },
    mounted () {
      //console.log(this.value)
    },
    computed: {
      maxDay (){
        let month = parseInt(this.input[1])
        let thirty = [4, 6, 9, 11];
        if(month === 2){
          return 29
        }

        if(thirty.includes(month)){
          return 30
        }

        return 31
      }
    },
    watch: {
      // every time the value (v-model) changes, update the internal input value so we know what happens
      value (val) {
        if(!val){
          val = ['','','']
        } else {
          if(typeof val === 'string') {
            val = val.split('-')
          }
        }
        this.input = val
      },
      // make sure the v-model gets updated
      input(val) {
        val = val.join('-')
        this.$emit('input', val);
      }
    }
  }
</script>
